const ddadosValidacaoSolicitacao = {
  Titulo: "Validação de Processo",
  Campos: {
    NumeroSolicitacao: {
      Tipo: "number",
      TipoNumero: "long",
      Label: "Número da Solicitação",
      Tamanho: 15,
      Obrigatorio: true
    },
    CpfCnpj: {
      Tipo: "mask",
      Mascara: "CPFCNPJ",
      Label: "CPF/CNPJ",
      Obrigatorio: true
    }
  }
};

export { ddadosValidacaoSolicitacao };
